import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', icon: '📊', label: 'Dashboard' },
  { path: '/inventory', icon: '🚗', label: 'Inventory' },
  { path: '/vehicles/add', icon: '➕', label: 'Add Vehicle' },
  { path: '/customers', icon: '👥', label: 'Customers' },
  { path: '/deals', icon: '🤝', label: 'Deals' },
  { path: '/import', icon: '📥', label: 'Import CSV' },
  { path: '/feed', icon: '📡', label: 'Website Feed' },
];

export default function Sidebar({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={{ width: 220, background: '#111', borderRight: '1px solid #222', display: 'flex', flexDirection: 'column', position: 'fixed', height: '100vh', zIndex: 100, overflowY: 'auto' }}>
      <div style={{ padding: 20, borderBottom: '1px solid #222' }}>
        <h2 style={{ color: '#cc0000', fontSize: 20, fontWeight: 800, letterSpacing: 1 }}>RED ZONE</h2>
        <p style={{ color: '#555', fontSize: 11, marginTop: 2 }}>DMS Platform</p>
      </div>
      <nav style={{ flex: 1, padding: '16px 0' }}>
        {navItems.map(item => {
          const active = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <div key={item.path} onClick={() => navigate(item.path)}
              style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 20px', color: active ? '#cc0000' : '#888', cursor: 'pointer', fontSize: 14, borderLeft: `3px solid ${active ? '#cc0000' : 'transparent'}`, background: active ? '#1a0000' : 'transparent', transition: 'all .2s' }}
              onMouseEnter={e => { if (!active) { e.currentTarget.style.color = '#e0e0e0'; e.currentTarget.style.background = '#1a1a1a'; }}}
              onMouseLeave={e => { if (!active) { e.currentTarget.style.color = '#888'; e.currentTarget.style.background = 'transparent'; }}}
            >
              <span style={{ fontSize: 18, width: 20, textAlign: 'center' }}>{item.icon}</span>
              {item.label}
            </div>
          );
        })}
      </nav>
      <div style={{ padding: '16px 20px', borderTop: '1px solid #222' }}>
        <div style={{ background: '#1a1a1a', borderRadius: 8, padding: 10, fontSize: 12, color: '#888', marginBottom: 10 }}>
          <strong style={{ color: '#e0e0e0', display: 'block', marginBottom: 2 }}>{user?.dealer_name || 'Dealership'}</strong>
          <span>{user?.name || ''}</span>
        </div>
        <button onClick={onLogout} style={{ width: '100%', padding: 8, background: 'transparent', border: '1px solid #333', borderRadius: 6, color: '#888', cursor: 'pointer', fontSize: 12 }}>Sign Out</button>
      </div>
    </div>
  );
}
